import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { CardModule } from 'primeng/card';
import { DatePickerModule } from 'primeng/datepicker';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { Table, TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { CheckpointService } from '../../shared/services/checkpoint-service';

@Component({
  selector: 'app-checkpoints-page',
  imports: [
    CommonModule,
    CardModule,
    ToastModule,
    TranslateModule,
    DatePickerModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    TableModule,
    MultiSelectModule,
    FormsModule,
  ],
  providers: [MessageService, CheckpointService],
  templateUrl: './checkpoints-page.component.html',
  styleUrl: './checkpoints-page.component.scss',
})
export class CheckpointsPageComponent implements OnInit {
  @ViewChild('checkpoints') checkpointTable!: Table;
  #messageService = inject(MessageService);
  checkpointService = inject(CheckpointService);

  checkpoints = this.checkpointService.checkpoints;

  // Computed properties für unique values - nutzen das gleiche Signal
  stationOptions = computed(() => {
    const checkpoints = this.checkpoints();
    const unique = [
      ...new Set(
        checkpoints.map((c) => c.station?.designation).filter(Boolean),
      ),
    ];
    return unique.map((value) => ({ label: value, value }));
  });

  routeOptions = computed(() => {
    const checkpoints = this.checkpoints();
    const unique = [
      ...new Set(checkpoints.map((c) => c.route?.name).filter(Boolean)),
    ];
    return unique.map((value) => ({ label: value, value }));
  });

  tagNameOptions = computed(() => {
    const checkpoints = this.checkpoints();
    const unique = [
      ...new Set(checkpoints.map((c) => c.tag_name).filter(Boolean)),
    ];
    return unique.map((value) => ({ label: value, value }));
  });

  beltNameOptions = computed(() => {
    const checkpoints = this.checkpoints();
    const unique = [
      ...new Set(checkpoints.map((c) => c.belt_name).filter(Boolean)),
    ];
    return unique.map((value) => ({ label: value, value }));
  });

  deviceOptions = computed(() => {
    const checkpoints = this.checkpoints();
    const unique = [
      ...new Set(checkpoints.map((c) => c.journey?.device_id).filter(Boolean)),
    ];
    return unique.map((value) => ({ label: value?.toString(), value }));
  });

  journeyOptions = computed(() => {
    const checkpoints = this.checkpoints();
    const unique = [
      ...new Set(checkpoints.map((c) => c.journey?.id).filter(Boolean)),
    ];
    return unique.map((value) => ({ label: value?.toString(), value }));
  });

  rangeDates: Date[] = [
    (() => {
      const date = new Date();
      date.setDate(date.getDate() - 7);
      date.setHours(0, 0, 0, 0);
      return date;
    })(),
    (() => {
      const date = new Date();
      date.setHours(23, 59, 59, 999);
      return date;
    })(),
  ];

  ngOnInit(): void {
    this.checkpointService.getCheckpoints({
      time_from: this.rangeDates[0],
      time_to: this.rangeDates[1],
    });
  }

  selectDateRange() {
    if (this.rangeDates[0] && this.rangeDates[1]) {
      const time_from = new Date(this.rangeDates[0]);
      time_from.setHours(0, 0, 0, 0);

      const time_to = new Date(this.rangeDates[1]);
      time_to.setHours(23, 59, 59, 999);

      this.checkpointService.getCheckpoints({
        time_from,
        time_to,
      });
    }
  }

  applyGlobalFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.checkpointTable.filterGlobal(filterValue, 'contains');
  }
}
